import useScrollAnimation from '../../../hooks/useScrollAnimation';
import { Helmet } from 'react-helmet-async';

import './homepage.css';

import HeroSection from './HeroSection';
import VideoInfoSection from './Section2';
import EventTimingSection from './Section3';
import TopicSection from './Section4';
import SpeakersSection from './Section5';
import TicketSection from './Section7';
import ScheduleSection from './Section6';
import AttendeeSection from './Section8';
import SponsorshipSection from './Section9';
import PartnershipSection from './Section10';

const HomePage = () => {
  useScrollAnimation();
  return (
    <main className='homepage-section'>
      <Helmet>
        <title>Home - Cosmos Conference 2024</title>
        <meta name="description" content="Welcome to Cosmos Conference 2024, an event that brings together the best minds." />
        <meta name="keywords" content="conference, cosmos, 2024" />
        <meta property="og:title" content="Cosmos Conference 2024" />
        <meta property="og:description" content="Join us for Cosmos Conference 2024!" />
        <meta property="og:image" content="https://cosmosconference.org/" />
        <link rel="canonical" href="https://cosmosconference.org/" />
      </Helmet>

      <HeroSection />
      <VideoInfoSection />
      <EventTimingSection />
      <TopicSection />
      <SpeakersSection />
      <ScheduleSection />
      <TicketSection />
      <AttendeeSection />
      <SponsorshipSection />
      <PartnershipSection />
    </main>
  )
}

export default HomePage